import { ClientComponentRunner } from '../../_common/client/client-component-runner';
import { viewTrackingFactory } from './tracking.factory';

const runner = new ClientComponentRunner(viewTrackingFactory, 'TrackingComponent');
runner.runClientJs();
